import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_INTEREST,
  USER_MARK_FAVOURITE,
  USER_SEND_FEEDBACK,
  USER_SEND_FEEDBACK_SUCCESS,
  USER_SEND_FEEDBACK_FAIL,
  USER_FEEDBACK_RESET
} from './constants';
import { createSelector } from 'reselect';
import { getUserEmail, isAuthenticated } from '../util/jwt';

const initialState = {
  user: {},
  userEmail: getUserEmail(),
  phone: null,
  loggingIn: false,
  loggedIn: isAuthenticated(),
  cowEnquiries: {},
  favourites: {},
  sendingFeedback: false,
  feedbackSent: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { ...state, loggingIn: true };
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        userEmail: action.data.email,
        user: action.data
      };
    case USER_LOGIN_FAIL:
      return { ...state, loggingIn: false, error: action.error };
    case USER_LOGOUT:
      return { ...state, userEmail: '', loggedIn: false, user: {} };
    case USER_REGISTER_INTEREST: {
      const userEmail = state.userEmail || action.email;
      const phone = state.phone || action.phone;
      const cowEnquiries = { ...state.cowEnquiries };
      const dateTime = new Date();
      cowEnquiries[action.cow.id] =
        cowEnquiries[action.cow.id] || { dateTime: dateTime.toISOString() };
      return { ...state, userEmail, phone, cowEnquiries };
    }
    case USER_MARK_FAVOURITE: {
      const favourites = { ...state.favourites };
      if (action.isFavourite) {
        favourites[action.cow.id] = action.cow;
      } else {
        delete favourites[action.cow.id];
      }
      return { ...state, favourites };
    }
    case USER_SEND_FEEDBACK:
      return { ...state, sendingFeedback: true };
    case USER_SEND_FEEDBACK_SUCCESS:
      return { ...state, sendingFeedback: false, feedbackSent: true };
    case USER_SEND_FEEDBACK_FAIL:
      return { ...state, sendingFeedback: false };
    case USER_FEEDBACK_RESET:
      return { ...state, feedbackSent: false };
  }
  return state;
};

const user = state => state.user.user;
const userEmail = state => state.user.userEmail;
const loggingIn = state => state.user.loggingIn;
const loggedIn = state => state.user.loggedIn;
const phone = state => state.user.phone;
const cowEnquiries = state => state.user.cowEnquiries;
const favourites = state => state.user.favourites;
const sendingFeedback = state => state.user.sendingFeedback;
const feedbackSent = state => state.user.feedbackSent;

export const getCurrentUser = createSelector(
  user, user => user
);

export const feedbackSuccessful = createSelector(
  feedbackSent, sent => sent
);

export const isSendingFeedback = createSelector(
  sendingFeedback, sending => sending
);

export const getLoggedInUser = createSelector( // really just the email
  userEmail, user => {
    return user;
  }
);

export const currentlyLoggingIn = createSelector(
  loggingIn, loggingIn => loggingIn
);

export const isLoggedIn = createSelector(
  loggedIn, loggedIn => loggedIn
);

export const getEmail = createSelector(
  userEmail, email => email
);

export const getPhone = createSelector(
  phone, phone => phone
);

export const hasPhoneOrEmail = createSelector(
  [phone, userEmail], (phone, email) => {
    return (!!phone || !!email);
  }
);

export const getEnquiryCowIDs = createSelector(
  cowEnquiries, enquiries => Object.keys(enquiries)
);

export const getFavouriteCows = createSelector(
  favourites, favourites => {
    const cows = Object.values(favourites);
    return cows || [];
  }
);

export default reducer;
